module.exports = __webpack_public_path__ + "static/media/metamask-fox.c06f3a3e.svg";